import React, { useEffect, useState } from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import LoadingButton from "../../component/LoadingButton";

import api from "../../../../services/api";

export default function Export({ campaign }) {
  const [loading, setLoading] = useState();

  const start = async () => {
    setLoading(true);
    const { data } = await api.post("/githeo_campaign/users", {
      campaignId: campaign._id,
      all: true,
    });
    exportData(data, campaign);
    setLoading(false);
  };

  return (
    <LoadingButton loading={loading} className="px-6 py-3.5 bg-secondary rounded-lg text-white font-semibold" onClick={start}>
      Export users
    </LoadingButton>
  );
}

async function exportData(entities, campaign) {
  if (!entities.length) return;

  const fileName = campaign.name + "-" + "users-" + new Date().toISOString();
  const customColumns = [
    "repo",
    "name",
    "url",
    "campaignId",
    "campaignName",
    "type",
    "languages",
    "login",
    "id",
    "public_repos",
    "followers",
    "following",
    "blog",
    "avatar_url",
    "emails",
    "company",
    "location",
    "blog",
    "bio",
    "twitter_username",
    "created_at",
    "updated_at",
    "hireable",
    "scrappedAt",
  ];

  const columns = customColumns.map((e) => e.title);

  const csv = [];

  for (let j = 0; j < entities.length; j++) {
    let obj = {};
    for (let i = 0; i < columns.length; i++) {
      let value = entities[j][customColumns[i]];
      if (customColumns[i] === "emails") value = value.length ? value[0] : "";
      if (Array.isArray(value)) value = value.join(", ");
      if (!value) value = "";
      obj = { ...obj, [customColumns[i]]: value };
    }
    csv.push(obj);
  }
  initiateFileDownload(csv, fileName);
}

function initiateFileDownload(csv, fileName) {
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(csv);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}
